<template>
  <div class="mid_nav_wrap seasidetms_no_category_menu mobile_mm">
    <slide-up-down :active="menuMobile" :duration="isMobile ? 1 : 1400">
      <nav>
        <div class="menu-primary-navigation-container">
          <MenuMobileNode :nodes="menuNodes" />
        </div>
      </nav>
      <div class="header_mid-buttons">
        <router-link
          tag="a"
          :to="`${$store.state.lang ? `/${$store.state.lang}` : ''}/service`"
          @click.native="setMenuMobile(false)"
        >
          {{ $t('repairCatalogContent') }}
        </router-link>
      </div>
      <div class="header_mid-language">
        <a
          href=""
          @click.prevent="changeLocale('ru')"
          :class="{ 'lang-active': $locale === 'ru' }"
          >RU</a
        >
        <a
          href=""
          @click.prevent="changeLocale('ua')"
          :class="{ 'lang-active': $locale === 'ua' }"
          >UA</a
        >
      </div>
    </slide-up-down>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import MenuMobileNode from '@/components/header/MenuMobileNode'
import MenuMixin from '@/components/header/MenuMixin'

export default {
  data() {
    return {
      fixed: false,
      isMobile: false,
    }
  },
  name: 'HeaderMenuMobile',
  components: { MenuMobileNode },
  mixins: [MenuMixin],
  computed: mapState(['menuMobile']),
  filterdLocales: function () {
    return this.locales.filter((item) => item != this.$locale)
  },
  methods: {
    ...mapMutations(['setMenuMobile']),
    changeLocale(locale) {
      let newPathname = ''
      this.menuMobile = false
      if (locale === 'ru' && this.$locale === 'ua') {
        newPathname = `/ru${window.location.pathname}`
        // newPathname = `/ru${this.$route.path}`

        this.$store.dispatch('changeLang', 'ru')
        this.$locale = locale
        this.$router.push(newPathname.replaceAll('//', '/'))
        this.$lang = locale
      } else if (locale === 'ua' && this.$locale === 'ru') {
        // console.log('to ua')
        // newPathname = this.$route.path.substring(3)
        newPathname = window.location.pathname.substring(3)

        this.$store.dispatch('changeLang', '')
        this.$locale = locale
        this.$router.push(newPathname.replaceAll('//', '/'))
        this.$lang = locale
      }
    },
    isFixed: function () {
      if (this.$route.path === '/') {
        if (window.pageYOffset > 220) {
          this.fixed = true
        } else {
          this.fixed = false
        }
      }
    },
  },
  beforeMount() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  mounted() {
    document.addEventListener('scroll', this.isFixed)
  },
}
</script>

<style>
div.mobile_mm .menu-primary-navigation-container {
  overflow-y: scroll;
}

.bot_nav_wrap
  .menu-primary-navigation-container
  .menu-item:not(.menu-has-depth-2)
  .sub-menu,
.bot_nav_wrap
  .menu-primary-navigation-container
  .menu-item.menu-has-depth-2
  .sub-menu
  .sub-menu {
  overflow: auto;
  max-height: 600px;
}
.header_mid-buttons {
  margin-top: -10px;
  padding: 9px 20px 9px 30px;
}
</style>
